import ChatThread from './ChatThread'
import { makeAuthorResolver } from './users'

export default function ChatSection({ chat, directChats, chatUsers, driverId, passengerIds }) {
  const resolveAuthor = makeAuthorResolver({ chatUsers, driverId })
  const passengers = new Set(passengerIds || [])
  const dms = directChats || []

  return (
    <div className='flex flex-col gap-2'>
      <ChatThread
        title='Chat del viaje'
        channel={chat}
        resolveAuthor={resolveAuthor}
        emptyLabel='Sin mensajes de usuario ⚠'
      />

      {dms.map(dm => {
        const counterpartId = ((dm.users || []).find(u => u.user_id !== driverId) || {}).user_id
        const counterpart = resolveAuthor(counterpartId, dm)
        return (
          <ChatThread
            key={dm._id}
            title={`Privado con ${counterpart.name}`}
            badge={counterpartId && !passengers.has(counterpartId) ? 'no viajó' : null}
            avatar={counterpart}
            channel={dm}
            resolveAuthor={resolveAuthor}
            emptyLabel='Sin mensajes de usuario'
          />
        )
      })}
    </div>
  )
}
